const Vue = require('vue')

const Router = require('vue-router')

import api from '@/util/api'
import config from '@/util/config'

Vue.use(Router)
import user from './user.js'
import order from './order.js'
import workgroup from './workgroup.js'

var router = new Router({
  mode: 'history',
  routes: [{
    path: "/",
    component: () => import( /* webpackChunkName: "home" */ '@/page/home.vue'),
    meta: {
      page: 'home',
      ignoreLogin: true
    },
    children: [{
      path: "m/:id?",
      alias: '',
      component: () => import( /* webpackChunkName: "home" */ '@/page/menuitem.vue'),
      meta: {
        page: 'home',
        ignoreLogin: true
      },
    }]
  },
  {
    path: "/user",
    component: () => import( /* webpackChunkName: "home" */ '@/page/user')
  },
  {
    path: "/error",
    component: () => import( /* webpackChunkName: "home" */ '@/page/error.vue'),
    meta: {
      ignoreLogin: true,
      iserror: true
    }
  },
  {
    path: '/loadRoutes',
    component: () => import( /* webpackChunkName: "home" */ '@/page/addRoutes.vue'),
  },
  ...user,
  ...order,
  ...workgroup
  ]
});

var toNext = (to, from, next) => {
  if (to.matched.length <= 0) {
    if (config.addRoutes) {
      next("/");
    } else {
      next("/loadRoutes?from=" + to.fullPath);
    }
  } else {
    next();
  }
}


var gonext = async (to, from, next) => {
  if (to.meta['iserror']) {
    toNext(to, from, next);
  } else if (config.userinfo.token) {
    toNext(to, from, next);
  } else {
    if (config.error) {
      next("/error");
    } else {
      if (to.meta['ignoreLogin']) {
        toNext(to, from, next);
      } else {
        if (config.userinfo.login_status === 0 && config.wx.isWX) {
          wxlogin(to);
        } else if (config.userinfo.login_status < 2) {
          var v = await config.showlogin();
          if (v) {
            await getUserInfo();
            toNext(to, from, next);
          } else {
            next("/");
          }
        } else {
          next("/");
        }
      }
    }
  }
}

var getToken = function () {
  var value = localStorage.getItem(config.localStorageKey);
  if (value != null) {
    config.userinfo.token = value;
  }
  return value;
}

var getUserInfo = function (p) {
  return api.user.getLoginData().then((res) => {
    if (res.R && res.data) {
      var data = res.data;
      config.setUserInfo(data);
      config.userinfo.login_status = 2;
    } else {
      config.clearUserInfo();
      config.userinfo.login_status = 0;
    }
    return res;
  })
}

var oauth = function (code) {
  config.error = '';
  return new Promise(async (resolve, reject) => {
    var res = await api.user.oauth(code);
    if (res == "" || res == null)
      config.error = '系统繁忙，请稍后在试';
    else {
      if (res.access_token) {
        config.setToken(res.access_token);
        config.userinfo.token = res.access_token;
        config.wx.code = code;
        config.userinfo.login_status = 2;
      } else {
        config.clearUserInfo();
        if (res.Code === 1) {
          config.wx.openid = res.OpenId;
          config.wx.unionid = res.UnionId;
          config.userinfo.login_status = 1;
          config.showlogin();
        } else if (res.Code === -1) {
          config.userinfo.login_status = 0;
          config.error = '微信授权失败';
        }
      }
    }
    resolve(res);
  })
}

var checkLogin = async function (to) {
  var res = await getToken();

  if (config.wx.isWX) {
    if (!config.userinfo.token && to.query["code"] && config.userinfo.login_status === 0) {
      var res = await oauth(to.query["code"]);
    }
  }

  if (config.userinfo.token) {
    var res1 = await getUserInfo(res);
    return res1;
  }
}

var wxlogin = async function (to) {
  return new Promise((resolve, reject) => {
    let appid = config.wx.appid;
    let url = config.host + to.path;
    let params = [];
    for (var key in to.query) { //剔除掉code
      if (key != "code" && key != "state" && to.query[key])
        params.push(`${key}=${to.query[key]}`);
    }
    if (params.length > 0) {
      url += "?" + params.join("&");
    }

    let scope = 'snsapi_userinfo' // snsapi_base 静默授权，snsapi_userinfo 弹出授权页面， snsapi_login 网页应用目前仅填写
    window.location.href = 'http://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=' + scope + '&state=1#wechat_redirect'
  })
}

router.beforeEach((to, from, next) => {
  if (!config.starturl) {
    config.starturl = to.fullPath;
  }
  var userinfo = config.userinfo;
  if (!userinfo.token) {
    checkLogin(to).then((res) => {

      gonext(to, from, next);
    }, () => {

      gonext(to, from, next);
    })
  } else {

    gonext(to, from, next);
  }
})

export default router;
